// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + "9560839e680f65f6a3dc" + ".js";
};